import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import Small from 'UIComponents/elements/Small';
import { ACTION_OUTPUTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import DataPassingPanelBodySingleDataSource from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelBodySingleDataSource';
import DataPassingPanelBodyActionOutputs from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelBodyActionOutputs';
import DataPanelSourceSkeleton from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPanelSourceSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataPassingPanelBody = ({
  actionId,
  dataSource,
  dataSourceError,
  disabled,
  dataSourceAllowList,
  propertyFieldTypeAllowList,
  propertyTypeAllowList,
  requiredPermissionLevel,
  flowId,
  hideNestedDataSources,
  isEmbedded,
  isFirstAction,
  loading,
  onDataPropertySelected,
  searchFilterString,
  selectedDataSourcePrefix,
  refetchDataSource
}) => {
  const {
    dataSourceDefinition = {}
  } = dataSource || {};
  const {
    name
  } = dataSourceDefinition;
  if (selectedDataSourcePrefix === ACTION_OUTPUTS && isFirstAction) {
    return /*#__PURE__*/_jsxs("div", {
      className: "p-left-9",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.ux-revised-mode.no-action-outputs.title"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.ux-revised-mode.no-action-outputs.description"
        })
      })]
    });
  }

  // Dev Note: When switching data sources there is a chance we are requesting the new one, but we are
  // still getting info for the old data source instead of the newly requested on.
  // Display a loading state in that case so we don't display the wrong thing
  if (loading || !dataSource || name !== selectedDataSourcePrefix) {
    return /*#__PURE__*/_jsx(DataPanelSourceSkeleton, {});
  }
  if (dataSourceError) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.ux-revised-mode.data-source-error"
      })
    });
  }
  if (selectedDataSourcePrefix === ACTION_OUTPUTS) {
    return /*#__PURE__*/_jsx(DataPassingPanelBodyActionOutputs, {
      actionId: actionId,
      dataSource: dataSource,
      disabled: disabled,
      dataSourceAllowList: dataSourceAllowList,
      propertyFieldTypeAllowList: propertyFieldTypeAllowList,
      propertyTypeAllowList: propertyTypeAllowList,
      requiredPermissionLevel: requiredPermissionLevel,
      flowId: flowId,
      onDataPropertySelected: onDataPropertySelected,
      searchFilterString: searchFilterString
    });
  }
  return /*#__PURE__*/_jsx(DataPassingPanelBodySingleDataSource, {
    dataSource: dataSource,
    disabled: disabled,
    dataSourceAllowList: dataSourceAllowList,
    propertyFieldTypeAllowList: propertyFieldTypeAllowList,
    propertyTypeAllowList: propertyTypeAllowList,
    requiredPermissionLevel: requiredPermissionLevel,
    flowId: flowId,
    hideNestedDataSources: hideNestedDataSources,
    onDataPropertySelected: onDataPropertySelected,
    searchFilterString: searchFilterString,
    refetchDataSource: refetchDataSource,
    isEmbedded: isEmbedded
  });
};
export default DataPassingPanelBody;